import { render, staticRenderFns } from "./XFiles.vue?vue&type=template&id=dab990ec&scoped=true"
import script from "./XFiles.vue?vue&type=script&lang=js"
export * from "./XFiles.vue?vue&type=script&lang=js"
import style0 from "./XFiles.vue?vue&type=style&index=0&id=dab990ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab990ec",
  null
  
)

export default component.exports